<template>
    <Breadcrumbs main="Learning" title="Detailed Course" />
    <div class="container-fluid">
        <div class="row">
            <courseDetail />
            <learningFilter />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const courseDetail = defineAsyncComponent(() => import("@/components/theme/learning/Course/courseDetail.vue"))
const learningFilter = defineAsyncComponent(() => import("@/components/commen/learningFilter.vue"))
</script>